(function () {
  'use strict';
  var PX = 'ag';
  function T() { return window.Theme; }
  function words() { var el = document.getElementById(PX + '-ui-strings'); try { return el ? JSON.parse(el.textContent) : {}; } catch (e) { return {}; } }
  function money(c) { try { return T().money.format(c); } catch (e) { return '$' + (Number(c || 0) / 100).toFixed(2); } }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; }); }
  function pic(src, w) {
    if (!src) return '<span class="' + PX + '-ui__ph" aria-hidden="true"></span>';
    var u = /^data:/.test(src) ? src : src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w * 2);
    return '<img src="' + esc(u) + '" alt="" width="' + w + '" height="' + w + '" loading="lazy">';
  }
  function count(n, W) { return n + ' ' + (n === 1 ? (W.item_one || 'item') : (W.item_other || 'items')); }
  function cartUrl() { return (T() && T().routes && T().routes.cart) || '/cart'; }
  function checkoutUrl() { return (T() && T().routes && T().routes.checkout) || '/checkout'; }
  var lastAdded = null, lastFocus = null;
  function trap(box, e) {
    if (e.key !== 'Tab') return;
    var f = box.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])'); if (!f.length) return;
    var a = f[0], z = f[f.length - 1];
    if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); } else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
  }
  function start(fn) { if (window.Theme && window.Theme.events) fn(); else document.addEventListener('DOMContentLoaded', function () { if (window.Theme) fn(); }); }

  var CHECK = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';
  var IC = {
    close: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18"/></svg>',
    minus: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M5 12h14"/></svg>',
    plus: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M12 5v14M5 12h14"/></svg>'
  };
  var root = document.documentElement, STILL_KEY = 'ag-still';
  function still() { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); }
  function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) { /* private window */ } }
  function def(name, cls) { if (!customElements.get(name)) customElements.define(name, cls); }

  /* Pause motion */
  function paused() { return root.classList.contains('ag-still'); }
  function syncPause() {
    var on = paused();
    [].slice.call(document.querySelectorAll('[data-ag-pause]')).forEach(function (b) { b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
  }
  if (lsGet(STILL_KEY) === '1') root.classList.add('ag-still');
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-ag-pause]') : null; if (!b) return;
    var on = !paused(); root.classList.toggle('ag-still', on); lsSet(STILL_KEY, on ? '1' : '0'); syncPause();
  });
  start(syncPause);

  /* the water line: scroll progress on every [data-ag-wl] */
  var wlRaf = 0;
  function wlUpdate() {
    wlRaf = 0;
    var h = root.scrollHeight - window.innerHeight, y = window.pageYOffset || root.scrollTop || 0;
    var p = h > 0 ? Math.max(0, Math.min(1, y / h)) : 0;
    [].slice.call(document.querySelectorAll('[data-ag-wl]')).forEach(function (el) { el.style.setProperty('--ag-p', p.toFixed(3)); });
  }
  function wlQueue() { if (!wlRaf) wlRaf = requestAnimationFrame(wlUpdate); }
  window.addEventListener('scroll', wlQueue, { passive: true });
  window.addEventListener('resize', wlQueue);
  def('ag-wline', class extends HTMLElement { connectedCallback() { wlQueue(); } });
  start(wlQueue);

  /* <ag-live>: loops pause while off screen */
  def('ag-live', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      if (!('IntersectionObserver' in window)) return;
      this._io = new IntersectionObserver(function (es) { self.classList.toggle('is-off', !es[es.length - 1].isIntersecting); }, { rootMargin: '0px' });
      this._io.observe(this);
    }
    disconnectedCallback() { if (this._io) this._io.disconnect(); }
  });

  /* <ag-spy>: anchors + current chip */
  function anchorId(a) {
    /* "#id" / "/#id" -> id */
    var h = a.getAttribute('href') || '', i = h.lastIndexOf('#');
    if (i < 0 || i === h.length - 1) return '';
    var id = h.slice(i + 1), base = h.slice(0, i).replace(/^#/, '');
    if (!id || id.charAt(0) === '/') return '';
    if (base && base !== '/' && base !== location.pathname) return '';
    return id;
  }
  def('ag-spy', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      this._on = {};
      this._click = function (e) {
        if (e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        var a = e.target.closest ? e.target.closest('a[href]') : null; if (!a) return;
        var id = anchorId(a); if (!id) return;
        var t = document.getElementById(id); if (!t) return;
        e.preventDefault();
        t.scrollIntoView({ behavior: still() ? 'auto' : 'smooth', block: 'start' });
        try { history.replaceState(null, '', '#' + id); } catch (er) { /* ok */ }
        if (!t.hasAttribute('tabindex')) t.setAttribute('tabindex', '-1');
        try { t.focus({ preventScroll: true }); } catch (er) { /* old browsers */ }
      };
      document.addEventListener('click', this._click);
      this._rs = function () { clearTimeout(self._rt); self._rt = setTimeout(function () { self.watch(); }, 200); };
      window.addEventListener('resize', this._rs);
      this.watch();
      this._pt = setTimeout(function () { self.prune(); }, 500);      /* after event-code.js */
    }
    prune() {
      [].slice.call(document.querySelectorAll('.ag-chip')).forEach(function (a) {
        var id = anchorId(a), li = a.closest('li'); if (!id || !li) return;
        var el = document.getElementById(id); li.hidden = !el || el.hidden;
      });
    }
    watch() {
      var self = this, els = [];
      if (this._io) { this._io.disconnect(); this._io = null; }
      this.links = [];
      [].slice.call(document.querySelectorAll('.ag-chip')).forEach(function (a) {
        var id = anchorId(a), el = id && document.getElementById(id);
        if (el) { self.links.push({ a: a, id: id, el: el }); if (els.indexOf(el) < 0) els.push(el); }
      });
      if (!els.length || !('IntersectionObserver' in window)) return;
      els.sort(function (a, b) { return (a.compareDocumentPosition(b) & 4) ? -1 : 1; });
      this._els = els;
      this._io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { self._on[en.target.id] = en.isIntersecting; });
        self.mark();
      }, { rootMargin: '-16px 0px -' + Math.round(window.innerHeight * 0.5) + 'px 0px', threshold: 0 });
      els.forEach(function (el) { self._io.observe(el); });
    }
    mark() {
      var cur = '', on = this._on;
      (this._els || []).forEach(function (el) { if (on[el.id]) cur = el.id; });
      this.links.forEach(function (l) {
        var is = l.id === cur;
        l.a.classList.toggle('is-current', is);
        if (is) l.a.setAttribute('aria-current', 'location'); else if (l.a.getAttribute('aria-current') === 'location') l.a.removeAttribute('aria-current');
      });
    }
    disconnectedCallback() {
      document.removeEventListener('click', this._click);
      window.removeEventListener('resize', this._rs);
      if (this._io) this._io.disconnect();
      clearTimeout(this._rt); clearTimeout(this._pt);
    }
  });

  /* <ag-in>: settles once its top passes 80% of the screen */
  def('ag-in', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      if (still() || this.getBoundingClientRect().top < window.innerHeight * 0.9) return;     /* on screen: nothing to arm */
      this.setAttribute('data-armed', '');
      this._on = function () {
        if (self._raf) return;
        self._raf = requestAnimationFrame(function () { self._raf = 0; var b = self.getBoundingClientRect(); if (b.top < window.innerHeight * 0.8 || b.bottom < 0) self.fire(); });
      };
      window.addEventListener('scroll', this._on, { passive: true }); window.addEventListener('resize', this._on);
      this._on();
    }
    fire() { this.unhook(); this.classList.add('is-in'); }
    unhook() { window.removeEventListener('scroll', this._on); window.removeEventListener('resize', this._on); }
    disconnectedCallback() { this.unhook(); }
  });

  /* <ag-levels>: the gauge fills down as the water front passes */
  def('ag-levels', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      if (still()) return;                                  /* at rest every level is already filled */
      this.setAttribute('data-armed', '');
      this.lv = [].slice.call(this.querySelectorAll('.ag-lv'));
      this._on = function () { if (!self._raf) self._raf = requestAnimationFrame(function () { self._raf = 0; self.update(); }); };
      window.addEventListener('scroll', this._on, { passive: true }); window.addEventListener('resize', this._on);
      this.update();
    }
    update() {
      var front = window.innerHeight * 0.62, rail = this.querySelector('.ag-levels__rail'), r = (rail || this).getBoundingClientRect();
      var p = Math.max(0, Math.min(1, (front - r.top) / Math.max(1, r.height)));
      this.style.setProperty('--ag-lv', p.toFixed(3));
      this.lv.forEach(function (el) {
        var m = el.querySelector('.ag-lv__mark'), b = m ? m.getBoundingClientRect() : el.getBoundingClientRect();
        el.classList.toggle('is-on', b.top + b.height / 2 < front);
      });
    }
    disconnectedCallback() { window.removeEventListener('scroll', this._on); window.removeEventListener('resize', this._on); }
  });

  /* <ag-calc>: how far does a tank go? */
  function num(v, d) { var n = parseFloat(v); return isNaN(n) ? d : n; }
  function tidy(n) { return String(Math.round(n * 10) / 10); }
  function fill(el, tpl, map) {
    if (!el) return;
    while (el.firstChild) el.removeChild(el.firstChild);
    String(tpl || '').split(/(\[[a-z]+\])/).forEach(function (part) {
      var k = part.slice(1, -1);
      if (part.charAt(0) === '[' && map.hasOwnProperty(k)) { var s = document.createElement('strong'); s.textContent = map[k]; el.appendChild(s); }
      else if (part) el.appendChild(document.createTextNode(part));
    });
  }
  def('ag-calc', class extends HTMLElement {
    connectedCallback() {
      var self = this, d = function (k) { return self.getAttribute('data-' + k) || ''; };
      this.tank = num(d('tank'), 67);
      this.oz = { single: num(d('single'), 1), double: num(d('double'), 2), latte: num(d('latte'), 2) + num(d('steam'), 1) };
      this.units = { single: d('u-single'), double: d('u-double'), latte: d('u-latte') };
      this.tpl = { head: d('head'), days: d('days'), daily: d('daily'), many: d('many'), per: d('per') };
      this.inp = this.querySelector('[data-ag-drinks]');
      this.out = { head: this.querySelector('[data-out="head"]'), days: this.querySelector('[data-out="days"]'), per: this.querySelector('[data-out="per"]') };
      this.minus = this.querySelector('[data-ag-step="-1"]'); this.plus = this.querySelector('[data-ag-step="1"]');
      if (!this.inp || !this.out.head) return;
      this._click = function (e) {
        var b = e.target.closest ? e.target.closest('[data-ag-step]') : null; if (!b) return;
        self.inp.value = Math.max(1, Math.min(8, self.n() + Number(b.getAttribute('data-ag-step')))); self.calc();
      };
      this._in = function () { self.calc(); };
      this._ch = function () { self.inp.value = self.n(); self.calc(); };
      this.addEventListener('click', this._click);
      this.addEventListener('input', this._in);
      this.addEventListener('change', this._ch);
      this.calc();
    }
    n() { var v = parseInt(this.inp.value, 10); return isNaN(v) ? 1 : Math.max(1, Math.min(8, v)); }
    type() { var c = this.querySelector('[data-ag-type]:checked'); return c ? c.value : 'double'; }
    calc() {
      var n = this.n(), t = this.type(), per = this.oz[t] || 1, count = Math.floor(this.tank / per), days = Math.floor(count / n), perday = per * n;
      var tpl = days < 1 ? this.tpl.many : (days === 1 ? this.tpl.daily : this.tpl.days);
      fill(this.out.head, this.tpl.head, { count: String(count), unit: this.units[t] });
      fill(this.out.days, tpl, { perday: String(n), days: String(days) });
      fill(this.out.per, this.tpl.per, { oz: tidy(perday) });
      if (this.minus) this.minus.disabled = n <= 1;
      if (this.plus) this.plus.disabled = n >= 8;
      var grid = this.closest('.ag-calcgrid');
      if (grid) grid.style.setProperty('--ag-band', Math.min(100, perday / this.tank * 100).toFixed(2) + '%');
    }
    disconnectedCallback() {
      this.removeEventListener('click', this._click); this.removeEventListener('input', this._in); this.removeEventListener('change', this._ch);
    }
  });

  /* <ag-delivery> */
  function addBiz(d, n) {
    var x = new Date(d.getTime());
    while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; }
    return x;
  }
  function shortDate(d) { try { return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); } catch (e) { return ''; } }
  def('ag-delivery', class extends HTMLElement {
    connectedCallback() {
      var lo = parseInt(this.getAttribute('data-min'), 10) || 7, hi = parseInt(this.getAttribute('data-max'), 10) || 10, now = new Date();
      var a = shortDate(addBiz(now, lo)), b = shortDate(addBiz(now, hi)), lead = this.querySelector('[data-ag-lead]'), win = this.querySelector('[data-ag-win]');
      if (!a || !b || !win) return;
      if (lead && lead.getAttribute('data-js')) lead.textContent = lead.getAttribute('data-js');
      win.textContent = a + ' – ' + b; win.hidden = false;
    }
  });

  /* <ag-pill> */
  def('ag-pill', class extends HTMLElement {
    connectedCallback() {
      var self = this, tgt = document.getElementById(this.getAttribute('data-target') || 'buy'), btn = tgt && tgt.querySelector('[data-add-button]');
      this.mq = window.matchMedia ? window.matchMedia('(max-width: 749px)') : { matches: false };
      this.s = { btn: true, past: false, fin: false, foot: false };
      if (!btn || !('IntersectionObserver' in window)) return;
      this._mq = function () { self.apply(); };
      if (this.mq.addEventListener) this.mq.addEventListener('change', this._mq);
      this._io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.target === btn) { self.s.btn = e.isIntersecting; self.s.past = !e.isIntersecting && e.boundingClientRect.top < 0; }
          else if (e.target.classList.contains('ag-foot')) self.s.foot = e.isIntersecting;
          else self.s.fin = e.isIntersecting;
        });
        self.apply();
      }, { threshold: 0 });
      [btn, document.querySelector('.ag-final'), document.querySelector('.ag-foot')].forEach(function (el) { if (el) self._io.observe(el); });
      this.apply();
    }
    apply() {
      var s = this.s, phone = !!this.mq.matches, on = phone && s.past && !s.btn && !s.fin && !s.foot;
      root.classList.toggle('ag-has-pill', phone);
      this.classList.toggle('is-in', on);
      if (on) { this.removeAttribute('aria-hidden'); this.removeAttribute('inert'); } else { this.setAttribute('aria-hidden', 'true'); this.setAttribute('inert', ''); }
    }
    disconnectedCallback() {
      if (this._io) this._io.disconnect();
      if (this.mq && this.mq.removeEventListener && this._mq) this.mq.removeEventListener('change', this._mq);
      root.classList.remove('ag-has-pill');
    }
  });

  /* sheet */
  var el = null, busy = false;
  function build() {
    if (el && document.body.contains(el)) return el;
    var W = words();
    el = document.createElement('div'); el.className = PX + '-ui'; el.setAttribute('aria-hidden', 'true');
    el.innerHTML = '<div class="' + PX + '-ui__scrim" data-ui-close></div>' +
      '<section class="' + PX + '-ui__sheet" role="dialog" aria-modal="true" aria-label="' + esc(W.title) + '" tabindex="-1">' +
        '<span class="' + PX + '-ui__crest" aria-hidden="true"></span>' +
        '<div class="' + PX + '-ui__head"><div class="' + PX + '-ui__headline"><span class="' + PX + '-ui__ok" aria-hidden="true">' + CHECK + '</span>' +
          '<h2 class="' + PX + '-ui__title" data-ui-title>' + esc(W.title) + '</h2></div>' +
          '<button type="button" class="' + PX + '-ui__close" data-ui-close aria-label="' + esc(W.close) + '">' + IC.close + '</button></div>' +
        '<div class="' + PX + '-ui__prog" aria-hidden="true"><span class="' + PX + '-ui__tank"><i></i></span><ol class="' + PX + '-ui__steps"><li class="is-on">' + esc(W.step_cart || 'Cart') + '</li><li>' + esc(W.step_checkout || 'Checkout') + '</li><li>' + esc(W.step_pay || 'Pay') + '</li></ol></div>' +
        '<div class="' + PX + '-ui__body" aria-live="polite"></div><div class="' + PX + '-ui__foot"></div>' +
      '</section>';
    el.addEventListener('click', function (e) {
      if (e.target.closest('[data-ui-close]')) { close(); return; }
      var q = e.target.closest('[data-ui-qty]');
      if (q && !busy) {
        busy = true;
        T().cart.change(q.getAttribute('data-key'), Number(q.getAttribute('data-ui-qty'))).then(function () { busy = false; return render(false); }).catch(function () { busy = false; });
      }
    });
    el.addEventListener('keydown', function (e) { if (e.key === 'Escape') { e.stopPropagation(); close(); return; } trap(el, e); });
    document.body.appendChild(el); return el;
  }
  function line(i, W, isNew) {
    var variant = i.variant_title && !/^default title$/i.test(i.variant_title) ? '<span class="' + PX + '-ui__var">' + esc(i.variant_title) + '</span>' : '';
    return '<div class="' + PX + '-ui__line' + (isNew ? ' is-new' : '') + '" data-key="' + esc(i.key) + '">' + pic(i.image, 72) +
      '<div><a class="' + PX + '-ui__name" href="' + esc(i.url) + '"' + (isNew ? ' data-new="' + esc(W.added_tag || 'Added') + '"' : '') + '>' + esc(i.product_title || i.title) + '</a>' + variant +
        '<div class="' + PX + '-ui__ctrl"><div class="' + PX + '-ui__qty" role="group" aria-label="' + esc(W.qty) + '">' +
          '<button type="button" data-ui-qty="' + (i.quantity - 1) + '" data-key="' + esc(i.key) + '" aria-label="' + esc(W.minus) + '">' + IC.minus + '</button>' +
          '<output>' + i.quantity + '</output>' +
          '<button type="button" data-ui-qty="' + (i.quantity + 1) + '" data-key="' + esc(i.key) + '" aria-label="' + esc(W.plus) + '">' + IC.plus + '</button></div>' +
          '<button type="button" class="' + PX + '-ui__rm" data-ui-qty="0" data-key="' + esc(i.key) + '">' + esc(W.remove) + '</button></div></div>' +
      '<span class="' + PX + '-ui__price">' + money(i.final_line_price) + '</span></div>';
  }
  function render(justAdded) {
    var W = words();
    return T().cart.get().then(function (c) {
      var body = el.querySelector('.' + PX + '-ui__body'), foot = el.querySelector('.' + PX + '-ui__foot');
      var newKey = justAdded && lastAdded && lastAdded.items && lastAdded.items[0] ? lastAdded.items[0].key : null;
      var title = el.querySelector('[data-ui-title]'), ok = el.querySelector('.' + PX + '-ui__ok');
      if (title) title.textContent = justAdded && c.items.length ? W.added : W.title;
      if (ok) ok.style.display = justAdded && c.items.length ? '' : 'none';
      body.innerHTML = c.items.length ? c.items.map(function (i) { return line(i, W, newKey && i.key === newKey); }).join('') : '<p class="' + PX + '-ui__empty">' + esc(W.empty) + '</p>';
      foot.innerHTML = '<div class="' + PX + '-ui__ev"></div><div class="' + PX + '-ui__sum"><span class="' + PX + '-ui__sum-label">' + esc(W.subtotal) + ' · ' + count(c.item_count, W) + '</span>' +
          '<span class="' + PX + '-ui__sum-value">' + money(c.total_price) + '</span></div>' +
        '<p class="' + PX + '-ui__ship">' + esc(W.ship) + '</p>' +
        (c.items.length ? '<div class="' + PX + '-ui__buttons"><a class="' + PX + '-ui__btn" href="' + esc(checkoutUrl()) + '">' + esc(W.checkout) + '</a>' +
          '<a class="' + PX + '-ui__btn ' + PX + '-ui__btn--ghost" href="' + esc(cartUrl()) + '">' + esc(W.view_cart) + '</a></div>' : '') +
        '<button type="button" class="' + PX + '-ui__keep" data-ui-close>' + esc(W.keep) + '</button>';
      var tpl = document.getElementById('ag-ev-cart'), box = foot.querySelector('.' + PX + '-ui__ev');
      if (box && tpl && tpl.content && c.items.length && tpl.content.querySelector('[data-ev]')) box.appendChild(tpl.content.cloneNode(true));
    });
  }
  function openUi(justAdded) {
    build();
    if (!el.classList.contains('is-open')) lastFocus = document.activeElement;
    return render(justAdded).then(function () {
      el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); root.style.overflow = 'hidden';
      var b = el.querySelector('.' + PX + '-ui__close'); if (b) { try { b.focus({ preventScroll: true }); } catch (e) { b.focus(); } }
    }).catch(function () {});
  }
  function close() {
    if (!el) return;
    el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); root.style.overflow = '';
    if (lastFocus && lastFocus.focus && document.body.contains(lastFocus)) { try { lastFocus.focus({ preventScroll: true }); } catch (e) { /* ok */ } }
    lastAdded = null;
  }
  function afterAdd(after) {
    if (after === 'cart') return false;
    openUi(true);
    return true;
  }
  function init() {
    /* top-line cart icon opens the sheet (not on the cart page) */
    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('.ag-top__cartlink') : null;
      if (!a || e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      if (document.querySelector('boostly-cart-items')) return;
      e.preventDefault(); openUi(false);
    });
  }

  start(function () {
    T().events.on('cart:added', function (e) { lastAdded = e.detail || null; });
    T().afterAddHook = function (after) { return afterAdd(after); };
    if (typeof init === 'function') init();
  });
})();

/* phone buy bar (<PX-mbar>) + cart checkout bar visibility */
(function () {
  'use strict';
  var PX = 'ag';
  function fmt(c) { try { return window.Theme.money.format(c); } catch (e) { return '$' + (Number(c || 0) / 100).toFixed(2); } }
  if (!customElements.get(PX + '-mbar')) customElements.define(PX + '-mbar', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.main = document.querySelector('.' + PX + '-pdp .product-form__submit');
      if (!this.main || !('IntersectionObserver' in window)) return;
      this.io = new IntersectionObserver(function (es) {
        var e = es[0]; self.show(!e.isIntersecting && e.boundingClientRect.top < 0);
      });
      this.io.observe(this.main);
      this.addEventListener('click', function (e) {
        if (!e.target.closest('[data-mbar-add]') || self.main.disabled) return;
        self.main.click();
      });
      this.onVariant = function (e) {
        var v = e.detail && e.detail.variant; if (!v) return;
        var p = self.querySelector('[data-mbar-price]'), b = self.querySelector('[data-mbar-add]');
        if (p) p.textContent = fmt(v.price);
        if (b) { b.disabled = !v.available; b.textContent = v.available ? self.dataset.add : self.dataset.sold; }
      };
      document.addEventListener('variant:change', this.onVariant);
    }
    show(on) { this.classList.toggle('is-in', on); document.documentElement.classList.toggle(PX + '-has-mbar', on); }
    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.onVariant) document.removeEventListener('variant:change', this.onVariant);
      document.documentElement.classList.remove(PX + '-has-mbar');
    }
  });
})();
